// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__sJUDG","validationTips":"StatementDescriptor_validationTips__7rb6D"};